import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatListModule } from '@angular/material/list';

@Component({
  selector: '',
  template: `
    <mat-selection-list #matListBox>
      <mat-list-option *ngFor="let item of listBoxSource">
        {{ item }}
      </mat-list-option>
    </mat-selection-list>
  `,
  styles: [
    `
      mat-selection-list {
        margin-top: 8px;
        width: 280px;
        height: 300px;
        overflow: auto;
      }
    `,
  ],
})
export class MatListBoxComponent implements OnInit, AfterViewInit {
  @Input() source: any;
  @ViewChild('matListBox') matListBox: MatListModule;
  checkedGridColumns: any;
  checkedItems: Array<any>;
  listBoxSource: any;

  constructor() {}
  ngOnInit() {
    if (this.source.length === 2) {
      this.listBoxSource = this.source[0];
    } else {
      this.listBoxSource = this.source;
    }
    //this.checkExistingColumns(this.source,this.checkedGridColumns)
  }

  ngAfterViewInit() {}

  onGroupsChange(checkedItems: string[]) {}

  checkExistingColumns(data: any, dataToCheck: any) {
    this.checkedItems = [];
    let checked = true;
    data.forEach((element) => {
      dataToCheck.find((subElement) => {
        if (element === subElement.caption) {
          this.checkedItems.push({ element, checked });
        } else {
          checked = false;
          this.checkedItems.push({ element, checked });
        }
      });
    });
  }

  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ) {}
}
